












import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import {
  SectionsModule,
  ArgumentsModule,
  CommentsModule,
  ChangeEventsModule
} from "@/store/store.helper";
import { eventBus } from "@/main";

@Component({})
export default class deletePopup extends Vue {
  @Prop() itemType: "section" | "argument" | "comment" | "changeEvent";
  @Prop() itemId: string;
  @SectionsModule.SectionsAction private deleteSection;
  @ArgumentsModule.ArgumentsAction private deleteArgument;
  @CommentsModule.CommentsAction private deleteComment;
  @ChangeEventsModule.ChangeEventsAction private deleteChangeEvent;

  async handleDelete() {
    await this[
      `delete${this.itemType.charAt(0).toUpperCase() + this.itemType.slice(1)}`
    ]({ id: this.itemId });
    this.close();
    eventBus.$emit("deleteFromParent", this.itemId);
    eventBus.$emit("mountVoteFeed");
  }

  close() {
    this.$emit("closePopup");
  }
}
